"use client";
import React, { useId, useState } from "react";
import { livelandingPageComponents } from "../../constants/livelanding-page.constants";

interface DisclaimerSectionProps {
  title: string;
  values: string[];
  className?: string;
  textClassName?: string;
}

const Disclaimer: React.FC<DisclaimerSectionProps> = ({
  title,
  values,
  className = "",
  textClassName = "",
}) => {
  const [showMore, setShowMore] = useState(false);
  const headingId = useId();
  const mobileContentId = useId();

  return (
    <section
      className={`bg-white !px-4 !py-2 sm:!px-4 sm:!py-4 md:!px-6 md:!py-4 ${className}`}
      aria-labelledby={headingId}
    >
      <h2
        id={headingId}
        className={`mb-2 font-[Rubik] !text-[14px] leading-[100%] font-medium tracking-[0px] text-gray-900 sm:!text-[16px] lg:!text-[20px] ${textClassName}`}
      >
        {title}
      </h2>

      {/* Full disclaimer for screens > 420px */}
      <div
        className={`hidden space-y-3 !text-[12px] leading-relaxed ${textClassName} max-[420px]:!hidden sm:!block sm:!text-[15px] lg:!text-[16px]`}
      >
        {values.map((val, idx) => {
          const key = val || `disclaimer-${idx}`;
          return (
            <p key={key} className="whitespace-pre-line">
              {val}
            </p>
          );
        })}
      </div>

      {/* Truncated + Read more only below 420px */}
      <div
        id={mobileContentId}
        className={`block font-[Rubik] !text-[12px] leading-relaxed ${textClassName} max-[420px]:!block sm:!hidden sm:!text-[14px] lg:!text-[16px]`}
        aria-live="polite"
      >
        {showMore ? (
          <div className="space-y-3">
            {values.map((val, idx) => {
              const key = val || `disclaimer-mobile-${idx}`;
              return (
                <p key={key} className="whitespace-pre-line">
                  {val}
                </p>
              );
            })}
          </div>
        ) : (
          <p className="text-[12px] whitespace-pre-line">
            {values[0]?.substring(0, 120)}...{" "}
            <button
              type="button"
              onClick={() => setShowMore(true)}
              className="font-medium text-[#FF6700] no-underline"
              aria-expanded={showMore}
              aria-controls={mobileContentId}
            >
              {livelandingPageComponents.READ_MORE}
            </button>
          </p>
        )}
      </div>
    </section>
  );
};

export default Disclaimer;
